import React from 'react'
import logo from '../../images/logo.png'
import { SlSocialLinkedin } from "react-icons/sl";
import { FiFacebook } from "react-icons/fi";
import { CiTwitter } from "react-icons/ci";
import { CiInstagram } from "react-icons/ci";
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer>
        
        <div className="container footer__container">
            <article>
                <Link to="/" className='logo'>
                    <img src={logo} alt="footer logo" />
                </Link>
                <p>
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quisquam, deserunt? Beatae, nostrum esse. Repellat reiciendis ipsum nostrum, voluptates vitae aperiam ducimus eum, obcaecati aliquid, perspiciatis consequatur. Aliquam mollitia molestias dolore.
                </p>
                <div className="footer__socials">
                    <a href="https://linkedin.com" target='_blank' rel='noreferrer noopener'><SlSocialLinkedin /></a>
                    <a href="https://Facebook.com" target='_blank' rel='noreferrer noopener'><FiFacebook /></a>
                    <a href="https://Twitter.com" target='_blank' rel='noreferrer '><CiTwitter /></a>
                    <a href="https://Instagram.com" target='_blank' rel='noreferrer '><CiInstagram /></a>

                </div>
            </article>

            <article>
                <h4>permalinkes</h4>
                <Link to="/about">About</Link>
                <Link to="/plans">plans</Link>
                <Link to="/trainers">Trainers</Link>
                <Link to="/gallery">gallery</Link>
                <Link to="/contact">contact</Link>

            </article>

            <article>
                <h4>permalinkes</h4>
                <Link to="/about">About</Link>
                <Link to="/plans">plans</Link>
                <Link to="/trainers">Trainers</Link>
                <Link to="/gallery">gallery</Link>
                <Link to="/contact">contact</Link>

            </article>

            <article>
                <h4>permalinkes</h4>
                <Link to="/about">About</Link>
                <Link to="/plans">plans</Link>
                <Link to="/trainers">Trainers</Link>
                <Link to="/gallery">gallery</Link>
                <Link to="/contact">contact</Link>

            </article>


        </div>

    </footer>
  )
}

export default Footer